import { DeliveryProvider } from '../../../../services/exports/Constants';

export default {
  [DeliveryProvider.Standalone]: 'Flotte von Restaurantfahrern',
  [DeliveryProvider.UberDrive]: 'Uber drive',
  [DeliveryProvider.WoltDrive]: 'Wolt drive',
};
